import { Dispatch, SetStateAction } from "react";
import { StateObjType, StateType } from "../pages/Landing/partner-forms/useCustomState";
import { getCityByPincode } from "../../services/area";

export function resetState(...setStateArray: Array<Dispatch<SetStateAction<StateType>>>) {
    setStateArray.forEach(setState => {
        setState(prevState => {
            const prev = prevState as StateObjType;
            return { ...prev, value: "" };
        });
    });
}

type Option = {
    value: string;
    label: string;
};

export function getOptions(list: any[], filterRegex: RegExp): Option[] {
    return list
        ?.map((item: any) => ({
            value: item._id,
            label: item.name
        }))
        ?.filter((item: any) => filterRegex.test(item.label));
}

export function getCityOnPincode(pincode: string, cities: any, setState: any) {
    try {
        let GetCity = async () => {
            let SCity = await getCityByPincode(pincode);
            cities.find((e: any) => {
                if (e._id === SCity._id) {
                    setState({ value: e.name, label: e.name })
                }
            })
        }
        GetCity()
    }
    catch (err: any) {
        console.log(err)
    }
}

// Function to extract unique tags
export function getUniqueTags(tags: any) {
    const uniqueTags = new Set(); // Using Set to ensure uniqueness

    // Iterate through each option and add tag to the set
    tags.forEach((tag: any) => {
        uniqueTags.add(tag);
    });

    return Array.from(uniqueTags); // Convert Set to Array and return
}

export function formatTimeToHHMM(dateString: any) {
    const date = new Date(dateString);

    // Get hours and minutes
    const hours = date.getHours();
    const minutes = date.getMinutes();

    // Ensure leading zero for single digit hours and minutes
    const formattedHours = hours < 10 ? `0${hours}` : hours;
    const formattedMinutes = minutes < 10 ? `0${minutes}` : minutes;

    // Concatenate hours and minutes with a colon to get HH:MM format
    const formattedTime = `${formattedHours}:${formattedMinutes}`;

    return formattedTime;
}